import api from "@basic/api";
import oss from "@basic/oss";
import auth from "./auth";
import errs from "./errs";
import func from "./func";

let withToken = async (config) => {
	await auth.ready; // wait auth ready
	config.headers["x-access-token"] = await auth.getToken();
	return config
};

let Grapher = api.http(process.env.VUE_APP_GRAPHER, {before: withToken, failure: errs.commonErr});
let Support = api.http(process.env.VUE_APP_SUPPORT, {failure: errs.commonErr});
let Resource = api.http(process.env.VUE_APP_RESOURCE, {failure: errs.commonErr});

let QuietGrapher = api.http(process.env.VUE_APP_GRAPHER, {before: withToken});

export default {
	v1: {
		app: {
			grapherPC: (platform) => window.urlMap[platform],
			grapherAndroid: () => `${process.env.VUE_APP_SUPPORT}/apps/efoto-pg-android/download`,
		},
		area: {
			all: (level) => Support.get("v1/areas/all/" + level)
		},
		auth: {
			sendCode: (mobile) => Grapher.post("v1/auth/code", {mobile: mobile}, {failure: errs.sendCodeErr}),
			loginSubmit: (args) => auth.login(args),
		},
		user: {
			detail: () => Grapher.get("v1/users"),
			setLogo: (logo) => Grapher.patch("v1/users/logo", {logo: logo}),
			setResume: (resume) => Grapher.patch("v1/users/resume", {info: resume}),
			setPassword: (args) => Grapher.patch("v1/users/password", args),
			space: {
				search: (args) => Grapher.get("v1/users/space", args),
				create: (args) => Grapher.post("v1/users/space", args),
				isPaid: (id) => Grapher.get(`v1/users/space/${id}/is_paid`),
				toPay: (id, args) => Grapher.post(`v1/users/space/${id}/to-pay`, args),
				prepay: (id) => Grapher.post(`v1/users/space/${id}/pre-pay`),
			},
			detect: {
				search: (args) => Grapher.get("v1/users/detect", args),
				create: (args) => Grapher.post("v1/users/detect", args),
				isPaid: (id) => Grapher.get(`v1/users/detect/${id}/is_paid`),
				toPay: (id, args) => Grapher.post(`v1/users/detect/${id}/to-pay`, args),
				prepay: (id) => Grapher.post(`v1/users/detect/${id}/pre-pay`),
			},
			ticket: (args) => Grapher.post(`v1/users/ticket`, {extend: args}),
			income: {
				search: (args) => Grapher.get("v1/users/income", args)
			},
			charge: {
				create: (args) => Grapher.post("v1/users/charge", args),
				isPaid: (id) => Grapher.get(`v1/users/charge/${id}/is_paid`)
			}
		},
		album: {
			vcode: (id) => Grapher.post(`v1/albums/${id}/vcode`, {}, {failure: errs.sendCodeErr}),
			search: (args) => Grapher.get("v1/albums", args),
			create: (args) => Grapher.post("v1/albums", {info: args}),
			setInfo: (id, args) => Grapher.patch(`v1/albums/${id}/info`, {info: args}),
			setConfig: (id, args) => Grapher.patch(`v1/albums/${id}/config`, {config: args}),
			setCopyright: (id, args) => Grapher.patch(`v1/albums/${id}/copyright`, {copyright: args}),
			detail: (id) => Grapher.get(`v1/albums/${id}`),
			delete: (id, code) => Grapher.delete(`v1/albums/${id}`, {code: code}),
			preview: (id) => `${process.env.VUE_APP_LIVEH5}/${id}`,
			intro: {
				get: (id) => Grapher.get(`v1/albums/${id}/intro`),
				set: (id, args) => Grapher.post(`v1/albums/${id}/intro`, args),
			},
			stats: {
				album: (id) => Grapher.get(`v1/albums/${id}/stats`),
				member: (id, members) => Grapher.get(`v1/albums/${id}/stats/member`, {ids: members}),
				folder: (id, folders) => Grapher.get(`v1/albums/${id}/stats/folder`, {ids: folders}),
			},
			advert: {
				search: (id) => Grapher.get(`v1/albums/${id}/adverts`),
				create: (id, args) => Grapher.post(`v1/albums/${id}/adverts`, {config: args}),
				update: (id, advertId, args) => Grapher.put(`v1/albums/${id}/adverts/${advertId}`, {config: args}),
				delete: (id, advertId) => Grapher.delete(`v1/albums/${id}/adverts/${advertId}`),
			},
			banner: {
				search: (id) => Grapher.get(`v1/albums/${id}/banners`),
				create: (id, args) => Grapher.post(`v1/albums/${id}/banners`, {config: args}),
				update: (id, bannerId, args) => Grapher.put(`v1/albums/${id}/banners/${bannerId}`, {config: args}),
				delete: (id, bannerId) => Grapher.delete(`v1/albums/${id}/banners/${bannerId}`),
			},
			photo: {
				oss: async (id, memberId) => {
					let instance = new oss(Grapher, `v2/albums/${id}/oss-ticket?member_id=${memberId}`);
					await instance.ready(); // wait oss ready
					return instance.uploader(Grapher, `v1/albums/${id}/oss-ticket?member_id=${memberId}`, 100);
				},
				ready: (id, start, finish) => Grapher.get(`v1/albums/${id}/photo-ready`, {
					start: start,
					finish: finish
				}),
				clean: (id, code) => Grapher.delete(`v1/albums/${id}/photo-clean`, {code: code}),
				search: (id, args) => Grapher.get(`v1/albums/${id}/photos`, args),
				myself: (id, args) => Grapher.get(`v1/albums/${id}/photos/myself`, args),
				retouchSearch: (id, args) => Grapher.get(`v1/albums/${id}/photos/retouch`, args),
				delete: (id, photos) => Grapher.post(`v1/albums/${id}/photos/delete`, {ids: photos}),
				action: (id, photos, flag, effect) => Grapher.post(`v1/albums/${id}/photos/action`, {
					ids: photos,
					flag: flag,
					effect: effect ? 1 : 2
				}),
				link: (id, photos, folderIds) => Grapher.post(`v1/albums/${id}/photos/link`, {
					ids: photos,
					folder_id: folderIds
				}),
				unlink: (id, photos, folderIds) => Grapher.post(`v1/albums/${id}/photos/unlink`, {
					ids: photos,
					folder_id: folderIds
				}),
				rotate: (id, photos, direction) => Grapher.post(`v1/albums/${id}/photos/rotate`, {
					ids: photos,
					direction: direction
				}),
				retouch: (id, photos) => Grapher.post(`v1/albums/${id}/photos/retouch`, {ids: photos}),
				URL: (id, photos) => Grapher.post(`v1/albums/${id}/photos/url`, {ids: photos}),
				hdURL: (id, photos) => Grapher.post(`v1/albums/${id}/photos/hd_url`, {ids: photos}),
				rawURL: (id, photos) => Grapher.post(`v1/albums/${id}/photos/raw_url`, {ids: photos}),
				oriURL: (id, photos) => Grapher.post(`v1/albums/${id}/photos/ori_url`, {ids: photos}),
			},
			folder: {
				search: (id) => Grapher.get(`v1/albums/${id}/folders`),
				create: (id, args) => Grapher.post(`v1/albums/${id}/folders`, {info: args}),
				update: (id, folderId, args) => Grapher.put(`v1/albums/${id}/folders/${folderId}`, {info: args}),
				delete: (id, folderId) => Grapher.delete(`v1/albums/${id}/folders/${folderId}`)
			},
			member: {
				ready: (id, isDelete) => {
					return new Promise(function (resolve) {
						let tryFunc = (level) => {
							if (level > 10) resolve();
							else {
								func.sleep(500).then(() => {
									QuietGrapher.get(`v1/albums/${id}/members`)
										.then(res => {
											if (res.total > 0 && !isDelete) resolve();
											else tryFunc(++level);
										})
										.catch(err => {
											if (err.err_code === 403000 && isDelete) resolve();
											else tryFunc(++level);
										});
								});
							}
						};
						tryFunc(1); // try func
					});
				},
				search: (id) => Grapher.get(`v1/albums/${id}/members`),
				create: (id, args) => Grapher.post(`v1/albums/${id}/members`, args),
				delete: (id, memberId, role) => Grapher.delete(`v1/albums/${id}/members/${memberId}/${role}`),
				comment: (id, memberId, role, comment) => Grapher.patch(`v1/albums/${id}/members/${memberId}/${role}/comment`, {comment: comment}),
			},
			watermark: {
				search: (id) => Grapher.get(`v1/albums/${id}/watermarks`),
				create: (id, args) => Grapher.post(`v1/albums/${id}/watermarks`, {config: args}),
				update: (id, watermarkId, args) => Grapher.put(`v1/albums/${id}/watermarks/${watermarkId}`, {config: args}),
				delete: (id, watermarkId) => Grapher.delete(`v1/albums/${id}/watermarks/${watermarkId}`),
				privilege: {
					create: (id) => Grapher.post(`v1/albums/${id}/watermarks/privilege`),
					toPay: (id, billId, args) => Grapher.post(`v1/albums/${id}/watermarks/privilege/${billId}/to-pay`, args),
					prepay: (id, billId) => Grapher.post(`v1/albums/${id}/watermarks/privilege/${billId}/pre-pay`),
					isPaid: (id, billId) => Grapher.get(`v1/albums/${id}/watermarks/privilege/${billId}/is-paid`)
				}
			},
			feeds: {
				search: (id, args) => Grapher.get(`v1/albums/${id}/feeds`, args)
			},
		},
		option: {
			cates: () => Grapher.get("v1/options/cate"),
		},
		support: {
			qrCode: (text, size) => `${process.env.VUE_APP_SUPPORT}/qr-code?text=${text}&size=${size}`,
		},
		resource: {
			create: (args) => Resource.post(`v1/resources`, args),
			download: (id, name) => `${process.env.VUE_APP_RESOURCE}/download/${id}?name=${name}`,
			createActionUrl: `${process.env.VUE_APP_RESOURCE}/v1/resources`,
			watermarkPreview: (id) => `${process.env.VUE_APP_RESOURCE}/wmconfigs/${id}`,
		},
		compare: (args) => Grapher.post("v1/compare", args),
	},
}
